import automation from "./automation.png"
import benefits from "./benefits.png"
import calculator from "./calculator.png"
import calendar from "./calendar.png"
import collaboration from "./collaboration.png"
import contracts from "./contracts.png"
import costs from "./costs.png"
import documents from "./documents.png"
import folder from "./folder.png"
import graduationHats from "./graduationHats.png"
import grow from "./grow.png"
import happyEarth from "./happyEarth.png"
import hired from "./hired.png"
import hiring1 from "./hiring1.png"
import hiring2 from "./hiring2.png"
import infinite from "./infinite.png"
import love from "./love.png"
import magic from "./magic.png"
import mail from "./mail.png"
import map1 from "./map1.png"
import map2 from "./map2.png"
import medal from "./medal.png"
import mission from "./mission.png"
import onboarding1 from "./onboarding1.png"
import onboarding2 from "./onboarding2.png"
import oysterSpot1 from "./oysterSpot1.png"
import payroll from "./payroll.png"
import people from "./people.png"
import rocket from "./rocket.png"
import secure1 from "./secure1.png"
import secure2 from "./secure2.png"
import teamwork from "./teamwork.png"
import tools from "./tools.png"

export const EmptyStateIllustration = {
  automation,
  benefits,
  calculator,
  calendar,
  collaboration,
  contracts,
  costs,
  documents,
  folder,
  graduationHats,
  grow,
  happyEarth,
  hired,
  hiring1,
  hiring2,
  infinite,
  love,
  magic,
  mail,
  map1,
  map2,
  medal,
  mission,
  onboarding1,
  onboarding2,
  oysterSpot1,
  payroll,
  people,
  rocket,
  secure1,
  secure2,
  teamwork,
  tools,
}
